import moment, { Duration } from 'moment';

export const normalizeDateTime = (
  date: Date,
  opts?: {
    res?: Response;
    delta?: Duration;
  },
): Date => {
  const responseDateString = opts?.res?.headers?.get('date') || opts?.res?.headers?.get('Date');
  if (!responseDateString) {
    return date;
  }
  const diff = moment(new Date()).diff(responseDateString, 's');
  const delta = opts?.delta || moment.duration({ second: 1 });
  return Math.abs(diff) > delta.asSeconds()
    ? moment(date)
        .add(diff, 's')
        .toDate()
    : date;
};

export const parseDateTime = (
  date: string,
  opts?: {
    res?: Response;
    delta?: Duration;
  },
): Date => normalizeDateTime(new Date(date), opts);

const hasCyrillic = (text?: string): boolean => !!text && /[а-яА-ЯЁё]/.test(text);

export const getCyrillicErrorMessage = (error: any): string | undefined => {
  const message =
    error?.data?.data?.code === 'FpsGenericError'
      ? (error?.data?.data?.details?.message as string | undefined)
      : undefined;
  return hasCyrillic(message) ? message : undefined;
};

export const getErrorCode = (error: any): string | undefined => error?.data?.data?.details?.code;
